// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pop List Container */
.pop-container { width: 80%; margin: 0 auto; padding: 10px; }

/* হেডার এবং সার্চ বার */
.pop-header-card {
    background: #0f172a;
    width: 60%;
    margin: auto;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid #1e293b;
    text-align: center;
}

.pop-title { color: #f8fafc; margin-bottom: 15px; }

.pop-search-input {
    width: 70%;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #334155;
    background: #1e293b;
    color: white;
    outline: none;
}

.pop-list { list-style: none; padding: 0; }

.pop-item {
    background: #0f172a;
    margin-bottom: 12px;
    border-radius: 10px;
    border: 1px solid #1e293b;
    padding: 15px 25px;
    transition: 0.3s;
}

.pop-item-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.pop-info { display: flex; align-items: center; gap: 15px; }

/* টাইপ অনুযায়ী ডট কালার */
.pop-status-dot { width: 12px; height: 12px; border-radius: 50%; }
.pop-status-dot.primary { background: #22c55e; box-shadow: 0 0 8px #22c55e; }
.pop-status-dot.secondary { background: #3b82f6; box-shadow: 0 0 8px #3b82f6; }
.pop-status-dot.others { background: #eab308; box-shadow: 0 0 8px #eab308; }

.pop-hostname { color: #f8fafc; font-size: 1.1rem; }

/* বাটন স্টাইল */
.pop-actions { display: flex; gap: 10px; }

.pop-btn {
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    color: white;
    font-weight: 600;
    transition: 0.2s;
}

.pop-btn.info { background: #64748b; }
.pop-btn.edit { background: #3b82f6; }
.pop-btn.delete { background:#f87171; }

/* ================= DETAILS ================= */
.pop-details-box {
  padding: 18px;
  border-top: 1px solid rgba(255,255,255,0.06);
  background: rgba(2,6,23,0.4);
  color: #FFFFFF;
}

.pop-details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.pop-details-card {
  padding: 12px;
  border-radius: 12px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.06);
}

.pop-details-card span {
  display: block;
  font-size: 0.75rem;
  color: #94a3b8;
}

.pop-details-card strong {
  color: #fff;
}

.pop-details-card.full {
  grid-column: span 2;
}

/* 📱 মোবাইল রেসপন্সিভ */
@media (max-width: 768px) {
    .pop-container { width: 95%; }
    .pop-header-card { width: 100%; }
    .pop-item-main { flex-direction: column; align-items: flex-start; gap: 15px; }
    .pop-actions { width: 100%; display: grid; grid-template-columns: 1fr 1fr; }
}`, "",{"version":3,"sources":["webpack://./src/components/InfoManage/PopList.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB,iBAAiB,UAAU,EAAE,cAAc,EAAE,aAAa,EAAE;;AAE5D,wBAAwB;AACxB;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,aAAa,cAAc,EAAE,mBAAmB,EAAE;;AAElD;IACI,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA,YAAY,gBAAgB,EAAE,UAAU,EAAE;;AAE1C;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,YAAY,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAE3D,0BAA0B;AAC1B,kBAAkB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACjE,0BAA0B,mBAAmB,EAAE,2BAA2B,EAAE;AAC5E,4BAA4B,mBAAmB,EAAE,2BAA2B,EAAE;AAC9E,yBAAyB,mBAAmB,EAAE,2BAA2B,EAAE;;AAE3E,gBAAgB,cAAc,EAAE,iBAAiB,EAAE;;AAEnD,gBAAgB;AAChB,eAAe,aAAa,EAAE,SAAS,EAAE;;AAEzC;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,gBAAgB,mBAAmB,EAAE;AACrC,gBAAgB,mBAAmB,EAAE;AACrC,kBAAkB,kBAAkB,EAAE;;AAEtC,gDAAgD;AAChD;EACE,aAAa;EACb,4CAA4C;EAC5C,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;IACI,iBAAiB,UAAU,EAAE;IAC7B,mBAAmB,WAAW,EAAE;IAChC,iBAAiB,sBAAsB,EAAE,uBAAuB,EAAE,SAAS,EAAE;IAC7E,eAAe,WAAW,EAAE,aAAa,EAAE,8BAA8B,EAAE;AAC/E","sourcesContent":["/* Pop List Container */\n.pop-container { width: 80%; margin: 0 auto; padding: 10px; }\n\n/* হেডার এবং সার্চ বার */\n.pop-header-card {\n    background: #0f172a;\n    width: 60%;\n    margin: auto;\n    padding: 20px;\n    border-radius: 12px;\n    border: 1px solid #1e293b;\n    text-align: center;\n}\n\n.pop-title { color: #f8fafc; margin-bottom: 15px; }\n\n.pop-search-input {\n    width: 70%;\n    padding: 10px;\n    border-radius: 8px;\n    border: 1px solid #334155;\n    background: #1e293b;\n    color: white;\n    outline: none;\n}\n\n.pop-list { list-style: none; padding: 0; }\n\n.pop-item {\n    background: #0f172a;\n    margin-bottom: 12px;\n    border-radius: 10px;\n    border: 1px solid #1e293b;\n    padding: 15px 25px;\n    transition: 0.3s;\n}\n\n.pop-item-main {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.pop-info { display: flex; align-items: center; gap: 15px; }\n\n/* টাইপ অনুযায়ী ডট কালার */\n.pop-status-dot { width: 12px; height: 12px; border-radius: 50%; }\n.pop-status-dot.primary { background: #22c55e; box-shadow: 0 0 8px #22c55e; }\n.pop-status-dot.secondary { background: #3b82f6; box-shadow: 0 0 8px #3b82f6; }\n.pop-status-dot.others { background: #eab308; box-shadow: 0 0 8px #eab308; }\n\n.pop-hostname { color: #f8fafc; font-size: 1.1rem; }\n\n/* বাটন স্টাইল */\n.pop-actions { display: flex; gap: 10px; }\n\n.pop-btn {\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    color: white;\n    font-weight: 600;\n    transition: 0.2s;\n}\n\n.pop-btn.info { background: #64748b; }\n.pop-btn.edit { background: #3b82f6; }\n.pop-btn.delete { background:#f87171; }\n\n/* ================= DETAILS ================= */\n.pop-details-box {\n  padding: 18px;\n  border-top: 1px solid rgba(255,255,255,0.06);\n  background: rgba(2,6,23,0.4);\n  color: #FFFFFF;\n}\n\n.pop-details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.pop-details-card {\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(255,255,255,0.04);\n  border: 1px solid rgba(255,255,255,0.06);\n}\n\n.pop-details-card span {\n  display: block;\n  font-size: 0.75rem;\n  color: #94a3b8;\n}\n\n.pop-details-card strong {\n  color: #fff;\n}\n\n.pop-details-card.full {\n  grid-column: span 2;\n}\n\n/* 📱 মোবাইল রেসপন্সিভ */\n@media (max-width: 768px) {\n    .pop-container { width: 95%; }\n    .pop-header-card { width: 100%; }\n    .pop-item-main { flex-direction: column; align-items: flex-start; gap: 15px; }\n    .pop-actions { width: 100%; display: grid; grid-template-columns: 1fr 1fr; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
